import * as actionTypes from '../constants/transactions';

const initialState = {
	transactionsPending: { data: [], links: {}, meta: {} },
	transactionsUpcoming: { data: [], links: {}, meta: {} },
	transactionsHistory: { data: [], links: {}, meta: {} },
	isFetchingTransactionsPending: false,
	isFetchingTransactionsUpcoming: false,
	isFetchingTransactionsHistory: false
};

const initialAction = {
	type: '',
	payload: {},
	message: ''
};
const transactions = (state = initialState, action = initialAction) => {
	switch (action.type) {
		case actionTypes.FETCH_TRANSACTIONS_UPCOMING_ALL_BEGIN:
			return {
				...state,
				isFetchingTransactionsUpcoming: true
			};
		case actionTypes.FETCH_TRANSACTIONS_UPCOMING_ALL_SUCCESS:
			return {
				...state,
				transactionsUpcoming: action.payload.transactionsUpcoming,
				isFetchingTransactionsUpcoming: false
			};
		case actionTypes.FETCH_TRANSACTIONS_UPCOMING_ALL_FAILURE:
			return {
				...state,
				isFetchingTransactionsUpcoming: false
			};
		case actionTypes.FETCH_TRANSACTIONS_PENDING_ALL_BEGIN:
			return {
				...state,
				isFetchingTransactionsPending: true
			};
		case actionTypes.FETCH_TRANSACTIONS_PENDING_ALL_SUCCESS:
			return {
				...state,
				transactionsPending: action.payload.transactionsPending,
				isFetchingTransactionsPending: false
			};
		case actionTypes.FETCH_TRANSACTIONS_PENDING_ALL_FAILURE:
			return {
				...state,
				isFetchingTransactionsPending: false
			};
		case actionTypes.FETCH_TRANSACTIONS_HISTORY_ALL_BEGIN:
			return {
				...state,
				isFetchingTransactionsHistory: true
			};
		case actionTypes.FETCH_TRANSACTIONS_HISTORY_ALL_SUCCESS:
			return {
				...state,
				transactionsHistory: action.payload.transactionsHistory,
				isFetchingTransactionsHistory: false
			};
		case actionTypes.FETCH_TRANSACTIONS_HISTORY_ALL_FAILURE:
			return {
				...state,
				isFetchingTransactionsHistory: false
			};

		case actionTypes.CHANGE_TRANSACTIONS_STATUS_BEGIN:
			return {
				...state,
				isFetchingTransactionsPending: true
			};
		case actionTypes.CHANGE_TRANSACTIONS_STATUS_SUCCESS:
			return {
				...state,
				isFetchingTransactionsPending: false
			};
		case actionTypes.CHANGE_TRANSACTIONS_STATUS_FAILURE:
			return {
				...state,
				isFetchingTransactionsPending: false
			};
		default:
			return state;
	}
};

export default transactions;
